import {AccommodationPageNavSections} from 'modules/accommodation/types'

import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'

export const useRoomsSectionScrollTarget = (): AccommodationPageNavSections => {
  const {isMobile} = useDeviceLayout()
  return isMobile
    ? AccommodationPageNavSections.RoomsFilters
    : AccommodationPageNavSections.Rooms
}
